"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("../styles");
var _TabScrollButton = _interopRequireDefault(require("./internal/TabScrollButton"));
var _excluded = ["classes", "TabIndicatorProps", "children", "scrollButtons", "allowScrollButtonsMobile", "variant", "widthVariant"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var styles = function styles(theme) {
  return {
    root: {
      backgroundColor: 'transparent'
    },
    cardLevelFlexContainer: {
      boxShadow: "inset 0 -1px 0 0 " + theme.palette.grey[300]
    },
    indicator: {
      height: '0.125rem',
      backgroundColor: theme.palette.ctaColor.base
    }
  };
};

/**
 * Use `Tabs` to group similar content into different sections on the same page.
 * @done true
 * @updated v7.4.0
 * @versionAdded v0.0.2
 * @examples
 *  TabsWithContent
 *  ScrollableButtonTab
 *  CardLevelTabs
 *  CardLevelTabsScrollableButtons
 */
var Tabs = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2.default)(Tabs, _Component);
  function Tabs(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    // create a ref to store the Tabs DOM element
    _this.state = {
      hideScrollButtons: false
    };
    _this.tabsContainer = /*#__PURE__*/_react.default.createRef();
    _this.updateScrollButtonsOnLoad = false;
    return _this;
  }
  var _proto = Tabs.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    // Options for the observer (which mutations to observe)
    var config = {
      attributes: true,
      childList: true,
      subtree: true
    };

    // Callback function to execute when mutations are observed
    var callback = function callback(mutationsList) {
      if (mutationsList && mutationsList.length > 0) {
        for (var _iterator = _createForOfIteratorHelperLoose(mutationsList), _step; !(_step = _iterator()).done;) {
          var mutation = _step.value;
          if (mutation.attributeName === 'disabled' && mutation.target.nodeName === 'BUTTON') {
            _this2.showOrHideScrollButtons();
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    this.observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    this.observer.observe(this.tabsContainer.current, config);

    // Call this here so that it triggers `componentDidUpdate()`
    this.showOrHideScrollButtons();
  };
  _proto.componentDidUpdate = function componentDidUpdate() {
    // This need to be called only once when the component is loaded.
    // With `componentDidMount()` it did not work and maybe DOM state
    // was not updated which is strange. After the first update MutationObserver
    // will take care of updating the state of scroll buttons.
    if (!this.updateScrollButtonsOnLoad) {
      this.showOrHideScrollButtons();
      this.updateScrollButtonsOnLoad = true;
    }
  };
  _proto.showOrHideScrollButtons = function showOrHideScrollButtons() {
    var buttons = this.tabsContainer.current.querySelectorAll('.tab-scroll-button:disabled');
    this.setState(function () {
      return {
        hideScrollButtons: buttons.length === 2
      };
    });
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    this.observer.disconnect();
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      classes = _this$props.classes,
      TabIndicatorProps = _this$props.TabIndicatorProps,
      childrenProp = _this$props.children,
      scrollButtons = _this$props.scrollButtons,
      allowScrollButtonsMobile = _this$props.allowScrollButtonsMobile,
      variant = _this$props.variant,
      widthVariant = _this$props.widthVariant,
      rest = (0, _objectWithoutPropertiesLoose2.default)(_this$props, _excluded);
    var _TabIndicatorProps,
      children = childrenProp;
    if (variant === 'card') {
      _TabIndicatorProps = (0, _extends2.default)({
        style: {
          display: 'none'
        }
      }, TabIndicatorProps);
      children = _react.default.Children.map(this.props.children, function (child) {
        return /*#__PURE__*/_react.default.cloneElement(child, {
          variant: _this3.props.variant
        });
      });
    } else {
      _TabIndicatorProps = (0, _extends2.default)({}, TabIndicatorProps);
    }
    var scrollButtonsProp = scrollButtons;
    if (scrollButtons) {
      scrollButtonsProp = 'auto';
    } else {
      scrollButtonsProp = false;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      ref: this.tabsContainer,
      className: "eds-tabs-container"
    }, /*#__PURE__*/_react.default.createElement(_material.Tabs, (0, _extends2.default)({
      classes: {
        root: classes.root,
        scroller: variant === 'card' && classes.cardLevelFlexContainer,
        indicator: classes.indicator
      },
      ScrollButtonComponent: function ScrollButtonComponent(props) {
        return /*#__PURE__*/_react.default.createElement(_TabScrollButton.default, (0, _extends2.default)({
          hideScrollButtons: _this3.state.hideScrollButtons
        }, props));
      },
      TabIndicatorProps: _TabIndicatorProps,
      scrollButtons: scrollButtonsProp,
      allowScrollButtonsMobile: allowScrollButtonsMobile,
      variant: widthVariant
    }, rest), children));
  };
  return Tabs;
}(_react.Component);
Tabs.muiName = 'Tabs';
Tabs.propTypes = {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports `updateIndicator()` action.
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: _propTypes.default.func,
  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: _propTypes.default.bool,
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes.default.object,
  /**
   * Send a custom class name.
   */
  className: _propTypes.default.string,
  /**
   * @ignore
   * Determines the color of the indicator.
   */
  indicatorColor: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.oneOf(['secondary', 'primary'])]),
  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {number} value We default to the index of the child
   */
  onChange: _propTypes.default.func,
  /**
   * Render the scroll buttons. If set to `true`, scroll buttons will be rendered if the tabs
   * don't fit in the current viewport.
   */
  scrollButtons: _propTypes.default.bool,
  /**
   * If set to `false`, scroll buttons are hidden in mobile viewports, even if `scrollButtons` is set to `true`.
   */
  allowScrollButtonsMobile: _propTypes.default.bool,
  /**
   * @ignore
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),
  /**
   * @ignore
   * Properties applied to the private `TabIndicator` element.
   */
  TabIndicatorProps: _propTypes.default.object,
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: _propTypes.default.any,
  /**
   * Set the variant to `page` to render a page level Tab.
   * Set the variant to `card` to render a card level Tab.
   */
  variant: _propTypes.default.oneOf(['page', 'card']),
  /**
   * Determines additional display behavior of the tabs:
   *   - scrollable will invoke scrolling properties and allow for horizontally scrolling (or swiping) of the tab bar.
   *   - fullWidth will make the tabs grow to use all the available space, which should be used for small views, like on mobile.
   *   - standard will render the default state.
   */
  widthVariant: _propTypes.default.oneOf(['scrollable', 'standard', 'fullWidth']),
  /**
  * The system prop that allows defining system overrides as well as additional CSS styles.
  */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
Tabs.defaultProps = {
  centered: false,
  widthVariant: 'scrollable',
  scrollButtons: false,
  allowScrollButtonsMobile: true,
  variant: 'page'
};
var _default = (0, _styles.withStyles)(styles, {
  index: 0
})(Tabs);
exports.default = _default;